import { PageOption } from './type'

const options: PageOption[] = [
  {
    name: 'dashboard',
    title: '看板',
    router: true
  },
  {
    name: 'comp',
    title: '组件示例',
    children: [
      {
        name: 'form-render',
        title: '表单渲染器',
        router: true
      },
      {
        name: 'data-table',
        title: '数据表格',
        router: true
      }
    ]
  },
  {
    name: 'example',
    title: '页面示例',
    children: [
      {
        name: 'query',
        title: '查询列表',
        router: true,
        children: [
          {
            name: 'edit',
            title: '编辑-{id}',
            router: { pathSuffix: '/:id', nested: false }
          }
        ]
      }
    ]
  },
  {
    name: 'todo',
    title: '合同审核',
    router: true
  },
  {
    name: 'contract',
    title: '合同管理',
    children: [
      {
        name: 'audit',
        title: '合同审批详情',
        menu: false,
        router: { pathSuffix: '/:id', nested: false }
      },
      {
        name: 'othercontract',
        title: '项目下的其他合同',
        menu: false,
        router: { pathSuffix: '/:id', nested: false }
      },
      {
        name: 'noncontract',
        title: '新增非标合同',
        menu: false,
        router: { pathSuffix: '/:id', nested: false }
      },
      {
        name: 'supplement-agreement',
        title: '新增非标合同',
        menu: false,
        router: { nested: false }
      },
      {
        name: 'contractdetail',
        title: '合同详情',
        menu: false,
        router: { pathSuffix: '/:id', nested: false }
      },
      {
        name: 'ledger',
        title: '合同台账',
        router: true,
        children: [
          {
            name: 'detail',
            title: '合同详情',
            router: { pathSuffix: '/:id', nested: false }
          },
          {
            name: 'signature',
            title: '设置签署方及签章位置',
            router: { pathSuffix: '/', nested: false }
          }
        ]
      }
    ]
  },
  {
    name: 'template',
    title: '合同模板库',
    children: [
      {
        name: 'category',
        title: '合同类型维护',
        router: true,
        children: [
          {
            name: 'add',
            title: '新增合同类型',
            router: { pathSuffix: '/', nested: false }
          },
          {
            name: 'list',
            title: '类型下所有模板',
            router: { pathSuffix: '/', nested: false }
          },
          {
            name: 'edit',
            title: '合同类型编辑-{id}',
            router: { pathSuffix: '/:id', nested: false }
          },
          {
            name: 'detail',
            title: '合同类型详情-{id}',
            router: { pathSuffix: '/:id', nested: false }
          }
        ]
      },
      {
        name: 'contract-group',
        title: '合同组维护',
        router: true,
        children: [
          {
            name: 'add',
            title: '新增合同类型',
            router: { pathSuffix: '/', nested: false }
          },
          {
            name: 'list',
            title: '组内所有模板',
            router: { pathSuffix: '/', nested: false }
          },
          {
            name: 'edit',
            title: '合同类型编辑-{id}',
            router: { pathSuffix: '/:id', nested: false }
          },
          {
            name: 'detail',
            title: '合同类型详情-{id}',
            router: { pathSuffix: '/:id', nested: false }
          }
        ]
      }, {
        name: 'contract-template-handle',
        title: '合同模板维护',
        router: true,
        children: [
          {
            name: 'add',
            title: '新增合同模板',
            router: { pathSuffix: '/', nested: false }
          },
          {
            name: 'edit',
            title: '合同模板编辑-{id}',
            router: { pathSuffix: '/:id', nested: false }
          },
          {
            name: 'detail',
            title: '合同模板详情-{id}',
            router: { pathSuffix: '/:id', nested: false }
          },
          {
            name: 'template-version-edit',
            title: '编辑版本',
            router: { pathSuffix: '/:id', nested: false }
          },
          {
            name: 'template-version-add',
            title: '新增版本',
            router: { pathSuffix: '/:id', nested: false }
          }
        ]
      }
    ]
  },
  {
    name: 'addnew',
    title: '新增合同',
    router: true
  }
]

export default options

// 生成全量权限
function gen(source: PageOption[] = options) {
  const ret: any[] = []
  source.forEach(v => {
    const children = v.children
    const item: any = { code: v.name }
    if (Array.isArray(children) && children.length > 0) {
      item.children = gen(children)
    }
    ret.push(item)
  })
  return ret
}

export const localAuthorities = gen()
